const apiConfig = {
    baseURL: process.env.REACT_APP_API_URL || "https://a066hilpa7.execute-api.eu-west-2.amazonaws.com/dev",
};

export default apiConfig;